import React from 'react'
import Container from 'react-bootstrap/Container';
import PageTitle from '../components/PageTitle';

// Media
import bathroom from '../../media/icons/bathroom.png';
import bedrooom from '../../media/icons/bedroom.png';
import powder_room from '../../media/icons/powder-room.png';
import oven from '../../media/icons/oven.png';
import refrigerator from '../../media/icons/refrigerator.png';
import window from '../../media/icons/window.png';
import cabinets from '../../media/icons/cabinets.png';
import sofa from '../../media/icons/sofa.png';
import staircase from '../../media/icons/staircase.png';


const Credits = () => {
    const icons = {
        bathrooms: bathroom,
        bedrooms: bedrooom,
        powder_rooms: powder_room,
        oven: oven,
        refrigerator: refrigerator,
        windows: window,
        cabinets: cabinets,
        furniture: sofa,
        staircases: staircase
    }
    
    const formatIcons = [
        {
            name: 'bedrooms',
            creatorName: 'Awsome',
            creator: 'kirantravelling2',
        },
        {
            name: 'bathrooms',
            creatorName: 'mangunkarsa',
            creator: 'mangunkarsa',
        },
        {
            name: 'powder_rooms',
            creatorName: 'Tim Boelaars',
            creator: 'timboelaars',
        },
        {
            name: 'oven',
            creatorName: 'DAVIVONGSA PATHRPOL',
            creator: 'davipath',
        },
        {
            name: 'refrigerator',
            creatorName: 'DAVIVONGSA PATHRPOL',
            creator: 'davipath',
        },
        {
            name: 'windows',
            creatorName: 'Iconspark',
            creator: 'iconsparks',
        },
        {
            name: 'cabinets',
            creatorName: 'Candy Design',
            creator: 'pakcandydesign',
        },
        {
            name: 'furniture',
            creatorName: 'Hanbai',
            creator: 'hanbaicon',
        },
        {
            name: 'staircases',
            creatorName: 'Fahrul Oktaviana',
            creator: 'fahrul_',
        },
    ]

    const source = 'http://www.thenounproject.com/'
    const sourceName = 'The Noun Project'

    const license = 'https://creativecommons.org/licenses/by/3.0/'
    const licenseName = 'CC BY-3.0 Attribution License'

  return (
    <div>
        <Container>
            <PageTitle title='DHCS - Credits' />

            <h1>Credits</h1>
            {
                formatIcons.map( item => (
                    <div key={item.name} className='m-5'>
                        <div className='quote--icon'>
                            <img src={icons[item.name]} alt={`${item.name} icon`} />
                        </div>
                        <p>
                            Icon by <a href={`https://thenounproject.com/creator/${item.creator}/`} className='link'>{item.creatorName}</a>,  cropped,
                            from <a href={source} className='link'>{sourceName}</a>, 
                            licensed under <a href={license} className='link'>{licenseName}</a>
                        </p>
                    </div>
                ))
            }
        </Container>
    </div>
  )
}

export default Credits
